import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
const ELFSIGHT_SCRIPT_ID = 'elfsight-platform';
const ELFSIGHT_APP_CLASS = 'elfsight-app-c13dd18b-2e06-4811-bc3c-dfee05772735';

/**
 * Google Bewertungen – eingebunden über das Elfsight-Widget,
 * damit Bewertungen und Sternedurchschnitt automatisch aktuell bleiben.
 */
export function GoogleReviews() {
  useEffect(() => {
    if (document.getElementById(ELFSIGHT_SCRIPT_ID)) return;
    const script = document.createElement('script');
    script.id = ELFSIGHT_SCRIPT_ID;
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <section id="google-bewertungen" aria-label="Google Bewertungen" className="w-full px-4 py-10 sm:px-6 sm:py-12" data-id="element-231" data-mp="2zeoymnbwe4t8">
      <div className="mx-auto mb-8 max-w-3xl text-center" data-id="element-232" data-mp="1sz4tpqf7a8kr">
        <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-white" data-id="element-233" data-mp="1nyh3h6yspvrl">
          Testimonials
        </span>
        <div className="relative inline-block" data-id="element-234" data-mp="2tbdwc0717u5b">
          <Sparkle className="animate-sparkle left-3 top-1 h-5 w-5 sm:-left-9 sm:h-7 sm:w-7" data-id="element-235" data-mp="2ya7cy1hm819p" />
          <Sparkle className="animate-sparkle-fast right-8 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-236" data-mp="2ka68kc256bph" />
          <h2 className="font-display text-gold-3d text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl lg:text-4xl" data-id="element-237" data-mp="2p8hjyr834u9t">
            Stimmen aus der Academy
          </h2>
        </div>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white sm:text-base" data-id="element-238" data-mp="2fajnxhjzht6n">
          Lies, wie unsere Teilnehmerinnen gestartet sind – und was sich seitdem verändert hat.
        </p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="mx-auto w-full max-w-[1300px]" data-id="element-239" data-mp="25k8i1pgqp9x4">
        {/* Skaliert das Widget leicht herunter, damit die Schriftgröße zum Rest der Seite passt. */}
        <div style={{
        zoom: 0.875
      }} data-id="element-240" data-mp="3tisssmu2dtxd">
          <div className={ELFSIGHT_APP_CLASS} data-elfsight-app-lazy data-id="element-241" data-mp="3thq32i8h9xj1" />
        </div>
      </motion.div>
    </section>;
}